import React, { useEffect } from 'react';

import AOS from 'aos';

import { Advantages } from '../components/Advantages';
import { Background } from '../components/Background';
import { Banner } from '../components/Banner';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Navbar } from '../components/Navbar';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
import { Videos } from '../components/Videos';

import 'aos/dist/aos.css';

export const Home = React.memo(() => {
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      setTimeout(() => {
        AOS.init({
          duration: 500,
          easing: 'ease-in-out',
          once: true,
        });

        AOS.refresh();
      }, 800);
    } else {
      AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: true,
      });

      AOS.refresh();
    }
  }, []);

  return (
    <div className="relative">
      <Background />
      <Navbar />
      <div className="z-10 flex flex-col">
        <Hero />
        {/* <Brands /> */}
        <Advantages />
        {/* <Benefits /> */}
        <Testimonials />
        <Videos />
        <Pricing />
        <FAQ />
        <Banner />
        <Footer />
      </div>
    </div>
  );
});
